import { FormikValues, useFormikContext } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { IMaskInput } from 'react-imask';

import { Grupo, Rotulo } from '.';
import Ajuda from './Ajuda';
import { FormContexto } from './Form';

interface Props {
  ajuda?: string;
  name: string;
  rotulo?: string;
  type?:
    | 'text'
    | 'date'
    | 'datetime'
    | 'datetime-local'
    | 'color'
    | 'email'
    | 'number'
    | 'password'
    | 'tel'
    | 'url'
    | 'time';
  semMargem?: boolean;
  prefixar?: string | React.ReactElement;
  mascara?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  aoAtualizar?: (valor: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  aoDeixar?: (valor: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forcarValor?: any;
  desabilitarAoForcar?: boolean;
}

const Campo = (props: Props): React.ReactElement => {
  const [desabilitado, setDesabilitado] = useState<boolean>(false);
  const { emLinha } = useContext(FormContexto);
  const {
    ajuda,
    name,
    type = 'text',
    rotulo,
    prefixar,
    forcarValor,
    desabilitarAoForcar = true,
  } = props;
  const { errors, handleBlur, handleChange, touched, values, setFieldValue } =
    useFormikContext<FormikValues>();

  useEffect(() => {
    if (forcarValor && !values[name]) {
      setFieldValue(name, forcarValor, true);

      if (desabilitarAoForcar) {
        setDesabilitado(true);
      }
    }
  }, [desabilitarAoForcar, forcarValor, name, setFieldValue, values]);

  const valor = () => {
    let valor: string | number | readonly string[] | undefined = '';

    if (name.includes('.')) {
      const chaves = name.split('.');

      valor = values[chaves[0]][chaves[1]][chaves[2]];
    } else {
      valor = values[name];
    }

    if (type == 'datetime-local' && valor) {
      return (valor as string).data().toFormat('yyyy-LL-dd\'T\'T');
    }
    if (type == 'date' && valor) {
      return (valor as string).data().toFormat('yyyy-LL-dd');
    }

    return valor;
  };

  const erro = () => {
    let erro = '';

    if (name.includes('.')) {
      const chaves = name.split('.');

      if (
        errors &&
        errors[chaves[0]] &&
        errors[chaves[0]][chaves[1]] &&
        errors[chaves[0]][chaves[1]][chaves[2]] &&
        touched &&
        touched[chaves[0]] &&
        touched[chaves[0]][chaves[1]] &&
        touched[chaves[0]][chaves[1]][chaves[2]]
      ) {
        erro = errors[chaves[0]][chaves[1]][chaves[2]];
      } else {
        erro = '';
      }
    } else {
      erro = errors[name] && touched[name] ? (errors[name] as string) : '';
    }

    return erro;
  };

  return (
    <Grupo
      semMargem={emLinha || props.semMargem}
      prefixar={prefixar}
      emLinha={emLinha}
    >
      {props.mascara ? (
        <IMaskInput
          type={type}
          name={name}
          className={`form-control ${erro() && 'is-invalid'}`}
          onChange={(e) => {
            if (props.aoAtualizar) {
              props.aoAtualizar(e.currentTarget.value);
            }

            handleChange(e);
          }}
          onBlur={(e) => {
            if (props.aoDeixar) {
              props.aoDeixar(e.currentTarget.value);
            }

            handleBlur(e);
          }}
          value={valor()}
          placeholder={rotulo}
          mask={props.mascara || ''}
          {...(desabilitado ? { disabled: true } : {})}
        />
      ) : (
        <input
          type={type}
          name={name}
          className={`form-control ${erro() && 'is-invalid'}`}
          onChange={(e) => {
            if (props.aoAtualizar) {
              props.aoAtualizar(e.currentTarget.value);
            }

            handleChange(e);
          }}
          onBlur={(e) => {
            if (props.aoDeixar) {
              props.aoDeixar(e.currentTarget.value);
            }

            handleBlur(e);
          }}
          value={valor()}
          placeholder={rotulo}
          {...(desabilitado ? { disabled: true } : {})}
        />
      )}
      <React.Fragment>
        {!emLinha && rotulo && <Rotulo name={name}>{rotulo}</Rotulo>}
      </React.Fragment>
      <React.Fragment>{ajuda && <Ajuda>{ajuda}</Ajuda>}</React.Fragment>
      <div className="invalid-tooltip">{erro()}</div>
    </Grupo>
  );
};

export default Campo;
